import script from "./SentenceExplanation.vue?vue&type=script&setup=true&lang=js"
export * from "./SentenceExplanation.vue?vue&type=script&setup=true&lang=js"

import "./SentenceExplanation.vue?vue&type=style&index=0&id=87733396&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87733396"]])

export default __exports__